const appConfig = {
  apiURL: process.env.REACT_APP_API_URL || '',
  googleAPIKey: process.env.REACT_APP_GOOGLE_API_KEY || ''
}

export { appConfig }
